import styled from 'styled-components';

import Channel from '@r1-frontend/ui-react/components/Channels/Channel';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    flex-direction: column;
    flex-grow: 1;
    margin-top: 24px;
    height: 100%;
`;

export const ChannelText = styled.p`
    ${FONTS.S};
    color: ${COLORS.TextPrimary};
`;

export const List = styled.div`
    height: 100%;
    align-content: flex-start;

    @media (max-width: ${wideBreakpoints.mobile}) {
        display: block;
    }
`;

export const ChannelWithMargin = styled(Channel)`
    margin-bottom: 16px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: row;
        width: 100%;
        max-width: 100%;
        margin-bottom: 14px;
        
        & > :first-child {
            margin-right: 14px;
        }
    }
`;
